<patron-toolbar>
  <div class="container">
    <div class="flex justify-content-between flex-wrap">
      <div class="my-2 flex align-items-center">
        <div class="me-2">
          <patron-sort-widget
            [findOptions]="findOptions"
            (onSubmit)="applyOrder($event)"></patron-sort-widget>
        </div>
        <div>
          <patron-filter-widget
            [findOptions]="findOptions"
            (onSubmit)="goToFirstPage()"></patron-filter-widget>
        </div>
      </div>
      <div class="my-2 flex align-items-center">
        <patron-search-widget
          (onSearch)="onSearch($event)"
          #searchWidget
          class="me-2"></patron-search-widget>
        @if (isEnableWrite) {
          <patron-button iconName="pi-plus" [routerLink]="openTicketRoute">
            Abrir chamado
          </patron-button>
        }
      </div>
    </div>
  </div>
</patron-toolbar>

<div class="container">
  <patron-responsive-table
    [bodyTemplate]="tableBody"
    [items]="tickets"
    [loading]="loading"
    [findOptions]="findOptions"
    (sortChanged)="paginate($event)">
    <ng-template #tableBody let-item>
      <tr (click)="onRowClicked(item)">
        <td>
          <patron-rt-column-title>
            <strong>Nº</strong>
          </patron-rt-column-title>
          <span [innerHTML]="item.ticket_number_teorema | highlight: findOptions.q"></span>
        </td>
        <td>
          <patron-rt-column-title>
            <strong>Data de abertura</strong>
          </patron-rt-column-title>
          {{ item.created_at | date: 'dd/MM/yyyy' }}
        </td>
        <!-- <td>
        <patron-rt-column-title>
          <strong>Problema</strong>
        </patron-rt-column-title>
        <div>
          <p class="mb-1" [innerHTML]="(item.summary || item.problem) | truncate:[50] | highlight: findOptions.q"></p>
          <patron-badge class="me-2" *ngIf="getSituationInfo(item.situation); let situation"
            [color]="situation.color">
            {{situation.label}}
          </patron-badge>
          <patron-badge color="info">
            {{item.system?.description}}
          </patron-badge>
        </div>
      </td> -->
        <td>
          <patron-rt-column-title>
            <strong>Responsável</strong>
          </patron-rt-column-title>
          {{ item.responsible?.name || 'Sem responsável' }}
        </td>
        <!-- <td>
      <patron-rt-column-title>
        <strong>Executor</strong>
      </patron-rt-column-title>
      {{item.executor?.name}}
    </td> -->
        <td>
          <patron-rt-column-title>
            <strong>Cliente</strong>
          </patron-rt-column-title>
          {{ item.customer_name || 'Sem cliente' }}
        </td>
        <!-- <td>
    <patron-rt-column-title>
      <strong>Solicitante</strong>
    </patron-rt-column-title>
    {{item.requester}}
  </td> -->
        <td>
          <patron-rt-column-title>
            <strong>Sistema</strong>
          </patron-rt-column-title>
          {{ item.system?.description }}
        </td>
        <!-- <td>
  <patron-rt-column-title>
    <strong>Projeto</strong>
  </patron-rt-column-title>
  {{item.project?.description}}
</td> -->
        <td>
          <patron-rt-column-title>
            <strong>Desenvolvedor</strong>
          </patron-rt-column-title>
          {{ item.developer?.name }}
        </td>
        <!-- <td>
<patron-rt-column-title>
  <strong>Esf. Tec</strong>
</patron-rt-column-title>
{{item.estimated_effort}}
</td> -->
        <!-- <td>
<patron-rt-column-title>
  <strong>Fase</strong>
</patron-rt-column-title>
{{item.phase?.description}}
</td> -->
        <!-- <td>
<patron-rt-column-title>
  <strong>Responsável</strong>
</patron-rt-column-title>
{{item.responsible?.name}}
</td> -->
        <td>
          <patron-rt-column-title>
            <strong>Status</strong>
          </patron-rt-column-title>
          @if (item.status) {
            <patron-badge [color]="getStatusClass(item.status)">
              {{ item.status.description }}
            </patron-badge>
          }
        </td>
        <!-- <td>
<patron-rt-column-title>
  <strong>Sprint</strong>
</patron-rt-column-title>
{{item.sprint?.description}}
</td> -->
        <!-- <td>
<patron-rt-column-title>
  <strong>Prioridade</strong>
</patron-rt-column-title>
{{item.priority}}
</td> -->
        <td>
          <patron-rt-column-title>
            <strong>Previsão</strong>
          </patron-rt-column-title>
          {{ item.expected_date | date: 'dd/MM/yyyy' }}
        </td>
      </tr>
    </ng-template>
  </patron-responsive-table>
</div>

<patron-toolbar position="bottom" [class.hidden]="!tickets.length">
  <patron-paginator
    [totalRecords]="totalItems"
    [findOptions]="findOptions"
    (onPageChange)="paginate($event)"
    #paginator>
  </patron-paginator>
</patron-toolbar>
